






import AppNotificationBar from "@/components/AppNotificationBar.vue";
import { NotificationSingle } from "@/types/notification";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({ components: { AppNotificationBar } })
export default class AppNotificationContainer extends Vue {
  @State(state => state.notifications.notifications)
  notifications!: NotificationSingle[];
}
